import { ActivityType } from '@/components/Activities'
import { ResponseArray } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import queryString from 'query-string'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'

export const getContractUpdates = async ({
    contractID,
    payload,
}: {
    contractID: number
    payload: Pick<DataGridPayload, 'page' | 'page_size'>
}) => {
    const response = await datacentral.get<ResponseArray<ActivityType>>(
        `/contracts/customers/${contractID}/updates?${queryString.stringify(payload)}`
    )
    return response?.data
}

export const createContractUpdate = async ({
    contractID,
    data,
}: {
    contractID: number
    data: any
}) => {
    const response = await datacentral.post(
        `/contracts/customers/${contractID}/updates`,
        {
            ...data,
        }
    )

    return response?.data
}
